// Une date tapée au clavier, lue comme on l'écrit ici : jour, mois, année.
// Le serveur, lui, attend AAAA-MM-JJ.

const pad = (n) => String(n).padStart(2, '0');

/** '2026-10-09' (ou '2026-10-09T08:00:00') → '09/10/2026'. */
export function isoVersTexte(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || '');
  return m ? `${m[3]}/${m[2]}/${m[1]}` : '';
}

/**
 * '09/10/2026', '9-10-26', '09.10.2026', '09102026' → '2026-10-09'.
 * Rend null pour une date incomplète ou qui n'existe pas (31/02).
 */
export function texteVersIso(texte) {
  const t = (texte || '').trim();
  let m = /^(\d{1,2})[/.\- ](\d{1,2})[/.\- ](\d{2}|\d{4})$/.exec(t)
       || /^(\d{2})(\d{2})(\d{4}|\d{2})$/.exec(t);
  if (!m) return null;

  const jour = Number(m[1]);
  const mois = Number(m[2]);
  // Sur deux chiffres, l'année est de ce siècle.
  const annee = m[3].length === 2 ? 2000 + Number(m[3]) : Number(m[3]);

  const d = new Date(annee, mois - 1, jour);
  if (d.getFullYear() !== annee || d.getMonth() !== mois - 1
      || d.getDate() !== jour) {
    return null;
  }
  return `${annee}-${pad(mois)}-${pad(jour)}`;
}

/** Pose les barres pendant la frappe : '09' → '09/', '09/10' → '09/10/'. */
export function completerFrappe(avant, apres) {
  if (apres.length <= avant.length) return apres;  // on efface : on laisse faire
  // La barre tapée après celle qu'on a posée ne se double pas.
  if (/\/\/$/.test(apres)) return apres.slice(0, -1);
  if (/^\d{2}$/.test(apres) || /^\d{1,2}\/\d{2}$/.test(apres)) {
    return `${apres}/`;
  }
  return apres;
}
